/**
 * MissionHistoryPage
 *
 * Displays completed missions with performance analytics
 * Container component using custom hooks and presentational components
 */

import { StatsCard } from '@/components/StatsCard';
import {
    // Hooks
    useMissionHistoryData,
    useMissionHistoryCharts,
    // Components
    MissionCard,
    MissionTypeChart,
    MissionDurationChart,
} from '@/features/mission-history';

export function MissionHistoryPage() {
    const { stats, recentMissions } = useMissionHistoryData();
    const { missionTypeChart, missionDurationChart } = useMissionHistoryCharts();

    return (
        <div className="w-full h-full bg-slate-950 p-8 overflow-y-auto text-slate-200 font-sans">
            <div className="mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-3xl font-semibold text-white mb-1">Mission History</h1>
                    <p className="text-slate-400">Completed missions and performance analytics</p>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-4 gap-6 mb-8">
                    {stats.map((stat) => (
                        <StatsCard key={stat.title} {...stat} />
                    ))}
                </div>

                {/* Charts Section */}
                <div className="grid grid-cols-2 gap-6 mb-8">
                    <MissionTypeChart 
                        series={missionTypeChart.series} 
                        labels={missionTypeChart.labels} 
                    />
                    <MissionDurationChart 
                        series={missionDurationChart.series} 
                        categories={missionDurationChart.categories} 
                    />
                </div>

                {/* Recent Missions */}
                <div>
                    <h2 className="text-xl font-semibold text-white mb-4">Recent Missions</h2>
                    <div className="space-y-4">
                        {recentMissions.map((mission) => (
                            <MissionCard key={mission.id} mission={mission} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
